<div class="flex flex-1 flex-row gap-5">
	<form #tenancyForm="ngForm" (ngSubmit)="submit(tenancyForm)" class="w-1/2">
		<h2>Pre-paid rent</h2>
		<app-input
			label="Adjustment title"
			[(ngModel)]="adjustment.title"
			placeholder="PRE-PAID RENT"
			name="title"
			class="mt-5"
		></app-input>
		<app-radio-group
			class="mt-3"
			[items]="areaItems"
			label="Area occupied"
			name="area"
			[(ngModel)]="adjustment.area"
			(ngModelChange)="changed()"
			type="compact"
		></app-radio-group>
		<app-input
			type="text"
			*ngIf="adjustment?.area === 'specify'"
			label="Description of area occupied"
			name="areaDescription"
			class="mt-3"
			[(ngModel)]="adjustment.areaDescription"
			(ngModelChange)="changed()"
		></app-input>
		<app-input
			type="cents"
			label="Pre-paid rent excl. HST"
			name="rent"
			class="mt-3"
			[startIcon]="ICON.DOLLAR"
			[(ngModel)]="adjustment.rent"
			(ngModelChange)="changed()"
			[required]="true"
			[submitted]="submitted"
		></app-input>
		<div class="mt-3">
			<app-checkbox
				label="Apply HST ({{ hst | percent }})"
				[(ngModel)]="adjustment.applyHst"
				(ngModelChange)="changed()"
				name="applyHST"
			></app-checkbox>
		</div>
		<app-radio-group
			class="mt-3"
			[items]="interestItems"
			label="Interest on pre-paid rent?"
			name="interest"
			[(ngModel)]="adjustment.interest"
			(ngModelChange)="changed()"
			type="compact"
		></app-radio-group>
		<app-radio-group
			*ngIf="adjustment.interest === 'yes'"
			class="mt-3"
			[items]="interestTypeItems"
			label="Interest type"
			name="interestType"
			[(ngModel)]="adjustment.interestType"
			(ngModelChange)="changed()"
			type="compact"
		></app-radio-group>
		<app-input
			type="number"
			*ngIf="
				adjustment.interest === 'yes' && adjustment.interestType === 'flat'
			"
			label="Enter interest rate"
			name="interestRate"
			class="mt-3"
			[startIcon]="ICON.PERCENTAGE"
			[(ngModel)]="adjustment.interestRate"
			(ngModelChange)="changed()"
		></app-input>
		<app-date-picker
			label="Tenancy commencement date"
			name="commencementDate"
			class="mt-3"
			[(ngModel)]="adjustment.commencementDate"
			(ngModelChange)="changed()"
			required
			[submitted]="submitted"
			maxDate="{{ adjustmentDate }}"
			maxDateErrorLabel="Adjustment Date"
		></app-date-picker>
		<app-input
			*ngIf="creditAmount >= 0"
			type="cents"
			label="Credit vendor"
			name="credit"
			class="mt-3"
			[startIcon]="ICON.DOLLAR"
			[ngModel]="creditAmount"
			[disabled]="true"
		></app-input>
		<app-input
			*ngIf="creditAmount < 0"
			type="cents"
			label="Credit purchaser"
			name="credit"
			class="mt-3"
			[startIcon]="ICON.DOLLAR"
			[ngModel]="creditAmount * -1"
			[disabled]="true"
		></app-input>
		<app-radio-group
			class="mt-3"
			[items]="formatItems"
			label="Printing format"
			name="format"
			[(ngModel)]="adjustment.format"
			(ngModelChange)="changed()"
			type="compact"
		></app-radio-group>
		<div class="mt-3">
			<app-checkbox
				label="Include all details in document"
				[(ngModel)]="adjustment.details"
				name="includeAllDetails"
			></app-checkbox>
		</div>
		<div class="flex justify-between mr-5 mt-5">
			<app-button btn="tertiary" class="mr-5" (click)="cancelModal()"
				>Cancel</app-button
			>
			<app-button type="submit">Save</app-button>
		</div>
	</form>
	<div class="w-1/2">
		<app-container type="dark" title="Details">
			<div class="flex flex-1 flex-col">
				<div class="mb-8">
					<div class="flex justify-between items-start mb-3">
						<div>Monthly occupancy fees</div>
						<div>{{ adjustment.rent | centsToDollars }}</div>
					</div>
					<div
						*ngIf="
							adjustment?.interest === 'yes' &&
							adjustment?.format === 'final' &&
							adjustment?.commencementDate
						"
						class="flex justify-between items-start mb-3"
					>
						<div>{{ interestLabel }}</div>
						<div>{{ interestTotal | centsToDollars }}</div>
					</div>
					<ng-container
						*ngIf="
							adjustment?.interest === 'yes' &&
							adjustment?.format === 'itemized' &&
							adjustment?.commencementDate
						"
					>
						<div
							*ngFor="
								let interest of interestAmount;
								trackBy: interestCompoundIndex
							"
							class="flex justify-between items-start mb-3"
						>
							<div>
								{{ interest.days }} days &#64;
								{{ interest.interestRate | percent: '1.0-2' }}
								<span class="text-sm">
									({{ interest.start | date: 'MMM/d/yy' }} -
									{{ interest.end | date: 'MMM/d/yy' }})
								</span>
							</div>
							<div>{{ interest.amount | centsToDollars }}</div>
						</div>
					</ng-container>
					<div
						*ngIf="adjustment?.applyHst"
						class="flex justify-end items-start mb-8"
					>
						<div>
							<strong
								>HST ({{ hst | percent }}) =
								{{ hstAmount | centsToDollars }}</strong
							>
						</div>
					</div>
					<div class="flex justify-end items-start">
						<div *ngIf="creditAmount >= 0">
							<strong
								>Credit Vendor = {{ creditAmount | centsToDollars }}</strong
							>
						</div>
						<div *ngIf="creditAmount < 0">
							<strong
								>Credit Purchaser =
								{{ creditAmount * -1 | centsToDollars }}</strong
							>
						</div>
					</div>
				</div>
			</div>
		</app-container>
	</div>
</div>
